import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { ParallaxSection } from './ParallaxSection';
export function ContactForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => setIsSubmitting(false), 2000);
  };
  return <>
      <section className="h-[1024px] px-4 flex items-center justify-center overflow-hidden" data-id="element-18">
        <ParallaxSection speed={0.25} data-id="element-19">
          <div className="max-w-3xl mx-auto w-full" data-id="element-20">
            <div className="text-center mb-12" data-id="element-21">
              <h2 className="text-3xl md:text-5xl font-bold mb-4 text-[#a1da52]" data-id="element-22">
                Contact Us
              </h2>
              <p className="text-white/80" data-id="element-23">
                Ready to accelerate your research? Schedule a demo today.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-6 bg-white/5 p-8 md:p-12 rounded-2xl border border-white/10 backdrop-blur-sm" data-id="element-24">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-25">
                <Input label="First Name" placeholder="Jane" required data-id="element-26" />
                <Input label="Last Name" placeholder="Doe" required data-id="element-27" />
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-28">
                <Input label="Email" type="email" placeholder="jane@company.com" required data-id="element-29" />
                <Input label="Company" placeholder="Organization Name" data-id="element-30" />
              </div>

              <div className="space-y-2" data-id="element-31">
                <label className="block text-sm font-medium text-white/90" data-id="element-32">
                  Message
                </label>
                <textarea className="w-full min-h-[120px] rounded-md border border-white/20 bg-white/5 px-3 py-2 text-sm text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#a1da52] focus-visible:ring-offset-2 ring-offset-[#042854] placeholder:text-white/40" placeholder="Tell us about your research needs..." data-id="element-33"></textarea>
              </div>

              <div className="pt-4" data-id="element-34">
                <Button type="submit" className="w-full md:w-auto min-w-[200px]" isLoading={isSubmitting} data-id="element-35">
                  Send Message
                </Button>
              </div>
            </form>
          </div>
        </ParallaxSection>
      </section>

      {/* Extra space to allow scrolling to see final animation stage */}
      <section className="h-[50vh]" data-id="element-36"></section>
    </>;
}